import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  // DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  // Box,
  // IconButton,
  // makeStyles,
  // Paper,
  // TableContainer,
  // Table,
  // TableHead,
  // TableRow,
  // TableBody,
  // TableCell,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { presentFormatedData } from "../../functionalComponents/dataFormatFunctions";
import CustomDatePickerMui from "../../models/inputs/DateInput";
import { ChevronRight, Warning } from "@material-ui/icons";
import BackDropLoading from "../../models/BackDrop";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import jwtDecode from "jwt-decode";
//import dayjs from "dayjs";

// const useStyles = makeStyles((theme) => ({
//   tableContainer: {
//     // backgroundColor: "#e3eef3",
//     // padding: "10px",
//     // marginBottom: "10px",
//     boxShadow: "none",
//   },
//   tableCell: {
//     textAlign: "left",
//     backgroundColor: "#c2e1ef",
//     borderBottom: "none", // Remove bottom border
//     // width: '16.666%', // Set equal width for each cell
//     padding: "16px", // Standard padding for consistency
//   },
//   headerCell: {
//     fontWeight: "bold",
//     whiteSpace: "nowrap",
//   },
// }));

// const reasonCodes = [
//   {
//     reasonCode: "PP-014",
//     reasonDescription:
//       "Manufacturing slots not available as per PO requirements",
//   },
//   { reasonCode: "PP-015", reasonDescription: "Raw material shortage" },
//   { reasonCode: "PP-016", reasonDescription: "Production capacity issue" },
//   { reasonCode: "none", reasonDescription: "-" },
// ];

const PONegotiationDialogBox = ({ open, handleClose, row, valueType }) => {
  // const classes = useStyles();
  const dispatch = useDispatch();
  const originalPO = useRef(row);
  // BCM-791: a propose action targets exactly ONE value (qty XOR date).
  // Default to "qty" so a legacy caller that omits the prop keeps a valid single-value shape.
  const vType = valueType === "date" ? "date" : "qty";
  const isQty = vType === "qty";
  const isDate = vType === "date";
  const valueLabel = isQty ? "Qty" : "Date";
  const partyLabel = localStorage.collabType !== "CMO" ? "BMS" : "CMO";
  const [reasonCodes, setReasonCodes] = useState([
    // { reasonCode: "none", reasonDescription: "-", reasonCodeID: "none" },
  ]);
  const [proposedDate, setProposedDate] = useState(
    localStorage.collabType !== "CMO"
      ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
        ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
        : row?.scheduleLineDetails?.cmoProposedDeliveryDate
        ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
        : row?.scheduleLineDetails?.committedDeliveryDate
        ? row?.scheduleLineDetails?.committedDeliveryDate
        : row?.scheduleLineDetails?.deliveryDate
      : row?.scheduleLineDetails?.cmoProposedDeliveryDate
      ? row?.scheduleLineDetails?.cmoProposedDeliveryDate
      : row?.scheduleLineDetails?.sponsorProposedDeliveryDate
      ? row?.scheduleLineDetails?.sponsorProposedDeliveryDate
      : row?.scheduleLineDetails?.committedDeliveryDate
      ? row?.scheduleLineDetails?.committedDeliveryDate
      : row?.scheduleLineDetails?.deliveryDate
  );
  const [proposedQty, setProposedQty] = useState(
    localStorage.collabType !== "CMO"
      ? row?.scheduleLineDetails?.sponsorProposedQuantity
        ? row?.scheduleLineDetails?.sponsorProposedQuantity
        : row?.scheduleLineDetails?.cmoProposedQuantity
        ? row?.scheduleLineDetails?.cmoProposedQuantity
        : row?.scheduleLineDetails?.committedQuantity
        ? row?.scheduleLineDetails?.committedQuantity
        : row?.scheduleLineDetails?.targetQuantity
      : row?.scheduleLineDetails?.cmoProposedQuantity
      ? row?.scheduleLineDetails?.cmoProposedQuantity
      : row?.scheduleLineDetails?.sponsorProposedQuantity
      ? row?.scheduleLineDetails?.sponsorProposedQuantity
      : row?.scheduleLineDetails?.committedQuantity
      ? row?.scheduleLineDetails?.committedQuantity
      : row?.scheduleLineDetails?.targetQuantity
  );
  const [selectedReason, setSelectedReason] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [duplicateValueError, setDuplicateValueError] = useState(false);
  const [dateInputError, setDateInputError] = useState(false);

  const isSameDate = (date1, date2) => {
    const d1 = new Date(date1).toISOString().split("T")[0]; // Extract YYYY-MM-DD
    const d2 = new Date(date2).toISOString().split("T")[0];
    return d1 === d2;
  };

  // BCM-791: the old changeInQty()/changeInDate() value-diff helpers were removed.
  // Approach A no longer derives the flags from a value diff — the popup targets exactly
  // one value, so the change flag is set directly from valueType (changeInQty: isQty,
  // changeInDate: isDate) in handleSave below.

  // Validation function to check if the SINGLE edited value matches the other party's value.
  // BCM-791: a qty popup compares only qty, a date popup compares only date.
  // Accepts optional overrides so callers (qty/date onChange) can check the
  // value being set before state has actually updated.
  const checkDuplicateValues = (qtyOverride = proposedQty, dateOverride = proposedDate) => {
    if (localStorage.collabType === "CMO") {
      // CMO is proposing - check against Sponsor's value of the edited type
      const sponsorQty = row?.scheduleLineDetails?.sponsorProposedQuantity;
      const sponsorDate = row?.scheduleLineDetails?.sponsorProposedDeliveryDate;

      if (isQty) {
        // Only flag a duplicate when the other party has a qty to compare against
        return sponsorQty != null
          ? parseFloat(qtyOverride) === parseFloat(sponsorQty)
          : false;
      }
      return sponsorDate ? isSameDate(dateOverride, sponsorDate) : false;
    } else {
      // Sponsor is proposing - check against CMO's value of the edited type
      const cmoQty = row?.scheduleLineDetails?.cmoProposedQuantity;
      const cmoDate = row?.scheduleLineDetails?.cmoProposedDeliveryDate;

      if (isQty) {
        return cmoQty != null
          ? parseFloat(qtyOverride) === parseFloat(cmoQty)
          : false;
      }
      return cmoDate ? isSameDate(dateOverride, cmoDate) : false;
    }
  };

  // Prepopulated values (qty/date default to the other party's value when this
  // party hasn't proposed one yet) can already match on open - flag it upfront.
  useEffect(() => {
    setDuplicateValueError(checkDuplicateValues());
  }, []);

  const handleSave = (type) => {
    // Check for duplicate values
    if (checkDuplicateValues()) {
      setDuplicateValueError(true);
      return;
    }

    // Validation: If reason code is not selected, comment is mandatory
    if ((!selectedReason || selectedReason === "none") && !comment.trim()) {
      setError(true);
      return;
    }
    
    // Validation: For specific reason codes, comment is mandatory
    if (
      (localStorage.collabType === "CMO" &&
        selectedReason === "EXMRP031" &&
        !comment.trim()) ||
      (localStorage.collabType !== "CMO" &&
        selectedReason === "EXMRP019" &&
        !comment.trim())
    ) {
      setError(true);
      return;
    }
    
    // If validation passes, proceed with save
    setError(false);
    dispatch({
      type: OPEN_BACKDROP,
      // backdropText: `Please don't refresh or close the tab while processing`,
    });
    // setButtonDisabled(false);

    let data = {
        vendorMosymphonyID: row?.scheduleLineDetails?.vendorMosymphonyID,
        scheduleAgreementStatusID:
          row?.scheduleLineDetails?.scheduleLineStatusID,
        scheduleAgreementStatusText:
          row?.scheduleLineDetails?.scheduleLineStatusText,
        schrockenSAID: row?.scheduleLineDetails?.schrockenSAID,
        scheduleAgreementNumber:
          row?.scheduleLineDetails?.scheduleAgreementNumber,
        vendorName: row?.scheduleLineDetails?.vendorName,
        sponsorName: row?.scheduleLineDetails?.sponsorName,
        productsList: row?.scheduleLineDetails
          ? [
              {
                fgMaterialCode: row?.scheduleLineDetails?.fgMaterialCode,
                fgMaterialName: row?.scheduleLineDetails?.fgMaterialName,
              },
            ]
          : [],
        poLineEditFlag: true,
        acceptOfferFlag: false,
        rejectOfferFlag: false,
        approveFlag: false,
        shareWithCMOFlag: type === "sharedWithCMO" ? true : false,
        confirmedFlag: false,
        poApprovedFlag: [21, 22, 23].includes(
          row?.scheduleLineDetails?.scheduleLineStatusID
        )
          ? false
          : true,
        approvalWorkFlowDetails: [],
        SLDetails: {
          ...row?.scheduleLineDetails,
          reasonCode: selectedReason !== "none" ? selectedReason : null,
          comments: comment,
          // BCM-791: write ONLY the edited value for the acting party; every other
          // proposed field keeps its existing value so a qty action never touches a
          // date (and vice-versa).
          sponsorProposedQuantity:
            localStorage.collabType !== "CMO" && isQty
              ? proposedQty
              : row?.scheduleLineDetails?.sponsorProposedQuantity,
          sponsorProposedDeliveryDate:
            localStorage.collabType !== "CMO" && isDate
              ? proposedDate
              : row?.scheduleLineDetails?.sponsorProposedDeliveryDate,
          cmoProposedQuantity:
            localStorage.collabType === "CMO" && isQty
              ? proposedQty
              : row?.scheduleLineDetails?.cmoProposedQuantity,
          cmoProposedDeliveryDate:
            localStorage.collabType === "CMO" && isDate
              ? proposedDate
              : row?.scheduleLineDetails?.cmoProposedDeliveryDate,
          // BCM-791 Approach A: exactly ONE change flag is true per action.
          changeInQty: isQty,
          changeInDate: isDate,
          markedForDelete: false,
        },
      };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updatePODetailsNew`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });

          handleClose("success");
        } else {
          handleClose("failed");
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        handleClose("failed");
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
      });

    // setTimeout(() => {
    //   dispatch({
    //     type: DESTROY_BACKDROP,
    //   });

    //   handleClose("success");
    // }, 3000);
  };
    const getOrganizationIdFromToken = () => {
        const authToken = localStorage.getItem("authToken"); // Get token from localStorage
        if (!authToken) return null; // Return null if no token is found
    
        try {
          const decodedToken = jwtDecode(authToken); // Decode the JWT token
          return decodedToken.collaborator_type_id || null; // Return collaborator_type_id or null if not found
        } catch (error) {
          console.error("Error decoding JWT token:", error);
          return null;
        }
      };
  const collaboratorTypeID = getOrganizationIdFromToken();

  useEffect(() => {
    const requestObject = {
      searchField: "all",
      searchValue: "",
      reasonCodeGroupType: "all",
      reasonCodeType: "all",
      status: "all",
      collaboratorTypeID: "all"
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`,
        requestObject
      )
      .then((res) => {
        if (res.data.status) {
          if (
            Array.isArray(res.data?.data?.reasonCodeList) &&
            res.data?.data?.reasonCodeList.length > 0
          ) {
            setReasonCodes(reasonCodes.concat(res.data.data.reasonCodeList));
          }
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  }, []);

  const hasQuantityChanged = (selectedLineitem) => {
    const sponsorProposedQty =
      selectedLineitem?.scheduleLineDetails?.sponsorProposedQuantity;
    const cmoProposedQty =
      selectedLineitem?.scheduleLineDetails?.cmoProposedQuantity;

    // console.log(
    //   "Sponsor Proposed Quantity:",
    //   sponsorProposedQty,
    //   "CMO Proposed Quantity:",
    //   proposedQty
    // );

    // Ensure CMO changes the quantity from the sponsor's proposed quantity
    return (
      proposedQty !== undefined &&
      proposedQty !== null &&
      proposedQty !== sponsorProposedQty
    );
  };

  // Rename changeInDate to hasDateChanged
  const hasDateChanged = (selectedLineitem) => {
    const sponsorProposedDate =
      selectedLineitem?.scheduleLineDetails?.sponsorProposedDeliveryDate;
    const cmoProposedDate =
      selectedLineitem?.scheduleLineDetails?.cmoProposedDeliveryDate;

    // console.log(
    //   "Sponsor Proposed Date:",
    //   sponsorProposedDate,
    //   "CMO Proposed Date:",
    //   proposedDate
    // );

    // Ensure CMO changes the date from the sponsor's proposed date
    return (
      proposedDate !== undefined &&
      proposedDate !== null &&
      sponsorProposedDate !== null &&
      !isSameDate(proposedDate, sponsorProposedDate)
    );
  };
  // console.log(
  //   "hasQuantityChanged:",
  //   hasQuantityChanged(originalPO.current ?? {})
  // );
  // console.log("hasDateChanged:", hasDateChanged(originalPO.current ?? {}));
  // console.log("selectedReason:", selectedReason);
  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <BackDropLoading />
      <DialogContent>
        <Grid container justifyContent="flex-end">
          <Typography
            variant="body2"
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              handleClose();
            }}
          >
            Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
          </Typography>
        </Grid>
        <Typography
          style={{
            fontWeight: "500",
            color: "black",
            fontSize: "2rem",
            margin: "1rem",
            textAlign: "center",
          }}
        >
          Edit {partyLabel} Proposed {valueLabel} for PO{" "}
          {row?.scheduleLineDetails?.scheduleAgreementNumber}
        </Typography>
        <Grid container spacing={3} style={{ marginTop: "1rem" }}>
          {/* BCM-791: qty popup shows only Proposed Qty + UoM (date field removed) */}
          {isQty && (
            <Grid item xs={4}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                {partyLabel} Proposed Qty
              </Typography>
              <TextField
                type="number"
                fullWidth
                value={proposedQty}
                //onChange={(e) => setProposedQty(e.target.value)}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (value > 0 || e.target.value === "") {
                    setProposedQty(e.target.value);
                    setDuplicateValueError(checkDuplicateValues(e.target.value, proposedDate));
                  }
                }}
                onKeyDown={(e) => {
                  if (["-", "+", "e", "E"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                variant="outlined"
                size="small"
                inputProps={{ min: 1 }}
              />
            </Grid>
          )}
          {isQty && (
            <Grid item xs={4}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                UoM
              </Typography>
              <Typography>
                {presentFormatedData(
                  row?.scheduleLineDetails?.targetQuantityUOM
                )}
              </Typography>
            </Grid>
          )}
          {/* BCM-791: date popup shows only Proposed Date (qty + UoM fields removed) */}
          {isDate && (
            <Grid item xs={4}>
              <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
                {partyLabel} Proposed Date
              </Typography>
              <CustomDatePickerMui
                fullWidth
                value={proposedDate}
                onChange={(date) => {
                  const newDate = date ? date.format("YYYY-MM-DD") + "T00:00" : "";
                  setProposedDate(newDate);
                  setDuplicateValueError(checkDuplicateValues(proposedQty, newDate));
                }}
                onError={(err) => setDateInputError(!!err)}
                disablePast // ✅ disables all past dates
              />
            </Grid>
          )}
        </Grid>

        {duplicateValueError && (
          <Grid container style={{ marginTop: "0.5rem" }}>
            <Grid item xs={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Warning style={{ color: "#FF0000", fontSize: "24px" }} />
                <Typography style={{ color: "#FF0000", textAlign: "start" }}>
                  {localStorage.collabType === "CMO"
                    ? `Edited CMO Proposed ${valueLabel} is matching BMS Proposed ${valueLabel}. Please enter a new ${valueLabel.toLowerCase()} or accept the BMS Proposed ${valueLabel} using the tick icon button.`
                    : `Edited BMS Proposed ${valueLabel} is matching CMO Proposed ${valueLabel}. Please enter a new ${valueLabel.toLowerCase()} or accept the CMO Proposed ${valueLabel} using the tick icon button.`}
                </Typography>
              </div>
            </Grid>
          </Grid>
        )}

        <Grid container spacing={3} style={{ marginTop: "1rem" }}>
          <Grid item xs={4}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Reason code / Description
            </Typography>
            <TextField
              select
              fullWidth
              value={selectedReason}
              onChange={(e) => {
                setError(false);
                setSelectedReason(e.target.value);
              }}
              variant="outlined"
              size="small"
              displayEmpty
              error={error && selectedReason === "none"}
              helperText={
                error && selectedReason === "none" ? "Select reason code" : ""
              }
              style={{ width: "600px" }}
            >
              <MenuItem value="none" disabled>
                Select Reason Code / Description
              </MenuItem>
              {reasonCodes.map((reason) => (
                <MenuItem key={reason.reasonCodeID} value={reason.reasonCode}>
                  {reason.reasonCode} / {reason.reasonDescription || ""}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {/* <Grid item xs={8}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Reason code description
            </Typography>
            <Typography>
              {reasonCodes.find((r) => r.reasonCode === selectedReason)
                ?.reasonDescription || "-"}
            </Typography>
          </Grid> */}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" style={{ marginBottom: "10px" }}>
              Comment
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={comment}
              onChange={(e) => {
                setError(false);
                if(e.target.value.length < 256){
                setComment(e.target.value);
                }
              }}
              variant="outlined"
              size="small"
              error={error}
              placeholder="Enter text here"
              // helperText={error ? "Comment is mandatory if reason code is not selected." : ""}
            />
            <Typography variant="caption" style={{ color: error && "red" }}>
              Note - If reason code is not entered, comment field is mandatory.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: 16, justifyContent: "center" }}>
        <Button
          variant="contained"
          color="primary"
          // disabled={!proposedQty || !proposedDate}
          //</DialogActions>
          //  disabled={
          //!(
          // !(
          //   ["none"].includes(selectedReason) ||
          //   (["none", "other"].includes(selectedReason) && !comment.trim())
          // )

          disabled={
            duplicateValueError ||
            dateInputError ||
            !(
              // Case 1: Reason code is selected (not "none")
              (selectedReason &&
                selectedReason !== "none" &&
                // If reason is EMXRP031 and user is CMO, comment must be filled
                ((selectedReason === "EXMRP031" &&
                  localStorage.collabType === "CMO" &&
                  comment.trim()) ||
                  // If reason is EXMRP019 and user is NOT CMO, comment must be filled
                  (selectedReason === "EXMRP019" &&
                    localStorage.collabType !== "CMO" &&
                    comment.trim()) ||
                  // For all other reasons, no comment check required
                  !["EXMRP031", "EXMRP019"].includes(selectedReason))) ||
              // Case 2: Reason code is not selected AND comment is entered
              ((!selectedReason || selectedReason === "none") && comment.trim())
            )
          }
          endIcon={<ChevronRight />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
          }}
          onClick={() => {
            if (
              localStorage.collabType !== "CMO" &&
              row?.scheduleLineStatusID === 21
            ) {
              handleSave("sharedWithCMO");
            } else {
              handleSave();
            }
          }}
        >
          {localStorage.collabType !== "CMO" && row?.scheduleLineStatusID === 21
            ? "Save changes and share with CMO"
            : "Save changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PONegotiationDialogBox;
